import { Property } from '../model/entity-type';
import { ExpressionValidationResult } from '../model/expression';
import { getSubqueryParameterType, ReportParameter } from '../model/report';
import { ExpressionReturnType } from './common';

export function parseReportParameter({
  parameter,
  properties,
  parseExpression
}: {
  parameter: ReportParameter;
  properties: Property[];
  parseExpression: (expression: string) => ExpressionValidationResult;
}):
  | { valid: true; type: ExpressionReturnType }
  | { valid: false; reason: string } {
  switch (parameter.type) {
    case 'expression':
      return parseExpression(parameter.expression);
    case 'literal-date':
    case 'month-date':
    case 'select-date':
      return { valid: true, type: 'date' };
    case 'literal-number':
      return {
        valid: true,
        type: 'decimal'
      };
    case 'select-number':
      return {
        valid: true,
        type: parameter.values.every(x => Number.isInteger(x.value))
          ? 'int'
          : 'decimal'
      };
    case 'activity':
    case 'user':
    case 'organization':
    case 'project':
    case 'choice':
      return {
        valid: false,
        reason: `Invalid parameter reference "${parameter.name}" - ${parameter.type} parameters are not supported in formulas.`
      };
    case 'subquery':
    case 'report-subquery': {
      const { type } = getSubqueryParameterType(parameter, properties);
      if (type) {
        return { valid: true, type };
      }
      return {
        valid: false,
        reason: `Invalid parameter reference "${parameter.name}". Unable to determine data type.`
      };
    }
    default:
      throw new Error(
        `Unexpected parameter type "${(parameter as any).type}".`
      );
  }
}
